import { Carousel } from 'react-bootstrap'
import styled, { css } from 'styled-components'

const CustomCarouselMixin = css`
    background: #161616;
    border: 1px solid #3e3e3e;
    box-sizing: border-box;
    border-radius: 100px;
    height: 45px;
    width: 45px;
`

export const CustomCarouselContainer = styled.div`
    /* padding: 3rem;
    border: 1px solid #434343; */
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`

export const CustomCarousel = styled(Carousel)<{ dont_show_arrow: boolean }>`
    width: 100%;

    .carousel-control-next {
        ${CustomCarouselMixin}
        top: 50%;
        right: 12px;
        opacity: 1;
        display: ${properties => (properties.dont_show_arrow ? 'none' : 'flex')};
        @media only screen and (max-width: 900px) {
            right: 0px;
        }
    }
    .carousel-control-prev {
        ${CustomCarouselMixin}
        top: 50%;
        left: 12px;
        opacity: 1;
        display: ${properties => (properties.dont_show_arrow ? 'none' : 'flex')};
        @media only screen and (max-width: 900px) {
            left: 0px;
        }
    }

    .carousel-control-next-icon {
        height: 40px;
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .carousel-control-prev-icon {
        height: 40px;
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`

export const CustomCarouselCounterWrapper = styled.div`
    padding: 0;
    display: flex;
    height: 30px;
    justify-content: space-between;
    box-sizing: border-box;
    border-radius: 50px;
    width: 100%;
    align-items: center;
    @media only screen and (min-width: 810px) {
        padding: 1rem;
    }
`

export const CustomCarouselCounter = styled.span`
    font-family: ${properties => properties.theme.variables.fontFamily.title};
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    color: ${properties => properties.theme.variables.colorText};
    @media only screen and (min-width: 810px) {
        font-size: 14px;
    }
`

export const SuccessNavItemTitleMain = styled.div`
    span {
        font-family: ${properties => properties.theme.variables.fontFamily.title};
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 1.2em;
        text-align: left;
        color: ${properties => properties.theme.variables.colorText};
        @media only screen and (min-width: 810px) {
            font-size: 14px;
        }
    }
`
